import { render } from "./AgentlistPage.vue?vue&type=template&id=e19a15d4&ts=true"
import script from "./AgentlistPage.vue?vue&type=script&lang=ts"
export * from "./AgentlistPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__